import {Link} from "react-router-dom";
import {translateKey} from "../language/translate";
import {Button} from "@wakelet/ui-kit";
import {UserAccounts} from "../auth/types";
import React, {FC, useState} from "react";
import {useAuth} from "../auth/AuthContext";
import {UserAccountStore} from "../auth/store";
import {UserAccountListItem} from "../user/UserAccountListItem";

export const SwitchAccount = () => {
  const [removeMode, setRemoveMode] = useState<boolean>(false);
  const toggleRemoveMode = () => setRemoveMode(!removeMode);
  if (removeMode) {
    return <SwitchAccountRemoveMode toggleRemoveMode={toggleRemoveMode} />
  }
  return <SwitchAccountOption toggleRemoveMode={toggleRemoveMode} />
};

type SwitchAccountProps = {
  toggleRemoveMode: () => void;
}

const SwitchAccountRemoveMode: FC<SwitchAccountProps> = ({toggleRemoveMode}) => {
  const {user} = useAuth();
  const {userAccounts, removeAccount} = useAccounts();
  const accounts = userAccounts.list();
  const accElements = accounts.map((account, index) => {
    const {email, displayName, provider, photoUrl} = account;
    const signedIn = user?.email === email;
    return <li key={index} className="mb-2">
      <UserAccountListItem
          account={index}
          email={email}
          displayName={displayName}
          photoURL={photoUrl}
          provider={provider}
          signedIn={signedIn}
          disabled={signedIn}
          onDelete={signedIn ? undefined : () => removeAccount(email)}/>
    </li>
  });
  accElements.push(<li key="remove-done" className="mb-2"><DoneButton onClick={toggleRemoveMode}/></li>);
  return (<div>
    <ol>{accElements}</ol>
  </div>);
};



const SwitchAccountOption: FC<SwitchAccountProps> = ({toggleRemoveMode}) => {
  const {user} = useAuth();
  const {userAccounts} = useAccounts();
  const accounts = userAccounts.list();
  const accElements = accounts.map((account, index) => {
    const {email, displayName, provider, photoUrl} = account;
    const signedIn = user?.email === email;
    return <li key={index} className="mb-2">
      {<UserAccountListItem
          account={index}
          email={email}
          displayName={displayName}
          photoURL={photoUrl}
          provider={provider}
          signedIn={signedIn}/>}
    </li>
  });
  accElements.push(<li key="add-an-account"><AddAnAccountButton/></li>);
  accElements.push(<li key="remove-an-account"><RemoveAccountButton onClick={toggleRemoveMode}/></li>);
  return (<div>
    <ol>{accElements}</ol>
  </div>);
};

const RemoveAccountButton: FC<{ onClick: () => void }> = ({onClick}) => {
  return <div className="mt-4">
    <Button variant="ghost" block onClick={onClick}>
      <Button.Label text={translateKey("account:switchAccount.remove")}/>
    </Button>
  </div>
};

const DoneButton: FC<{ onClick: () => void }> = ({onClick}) => {
  return <div className="mt-4">
    <Button variant="primary" block onClick={onClick}>
      <Button.Label text={translateKey("common:buttons.done")}/>
    </Button>
  </div>
};

const AddAnAccountButton = () => {
  return <div className="mt-4 text-center">
    <Button.Style variant="secondary" block>
      <Link to="/login">
        <Button.Label text={translateKey("account:switchAccount.add")}/>
      </Link>
    </Button.Style>
  </div>
};

type UserAccountsReturn = {
  userAccounts: UserAccounts,
  removeAccount: (email: string) => void
}

const useAccounts = (): UserAccountsReturn => {
  const [userAccounts, setUserAccounts] = useState<UserAccounts>(UserAccountStore.get());
  const removeAccount = (email: string) => {
    const accounts = UserAccountStore.get();
    accounts.remove(email);
    UserAccountStore.set(accounts);
    setUserAccounts(accounts);
  };
  return {userAccounts, removeAccount}
}


